import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GridModule } from '@progress/kendo-angular-grid';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { RoomsComponent } from './containers/rooms/rooms.component';
import { RestaurantComponent } from './containers/restaurant/restaurant.component';
import { BookingRoutingModule } from './booking.routing';
import { RoomDetailComponent } from './containers/room-detail/room-detail.component';
import { PaymentService } from './services/payment.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookingListComponent } from './containers/booking-list/booking-list.component';
import { BookingShellComponent } from './containers/booking-shell/booking-shell.component';
import { AddBookingComponent } from './containers/add-booking/add-booking.component';
import { BookingService } from './services/booking.service';
import { KeysPipe } from './pipes/keys.pipe';
import { ListGridComponent } from './components/list-grid/list-grid.component';
import { EditBookingComponent } from './containers/edit-booking/edit-booking.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsModalModule } from 'ng2-bs3-modal';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule, ButtonModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';

import { PersonalinfoComponent } from './form-components/personalinfo/personalinfo.component';
import { ConferenceinfoComponent } from './form-components/conferenceinfo/conferenceinfo.component';
import { AccomodationinfoComponent } from './form-components/accomodationinfo/accomodationinfo.component';
import { TourinfoComponent } from './form-components/tourinfo/tourinfo.component';
import { ConfirmationComponent } from './form-components/confirmation/confirmation.component';
import { RoomchoiceComponent } from './form-components/roomchoice/roomchoice.component';
import { AddBookingGuard } from './services/add-booking.guard';
import { ViewBookingComponent } from './containers/view-booking/view-booking.component';
@NgModule({
  declarations: [
    ListGridComponent,
    EditBookingComponent,
    KeysPipe,
    RoomsComponent,
    RestaurantComponent,
    RoomDetailComponent,
    BookingListComponent,
    BookingShellComponent,
    AddBookingComponent,
    PersonalinfoComponent,
    ConferenceinfoComponent,
    AccomodationinfoComponent,
    TourinfoComponent,
    ConfirmationComponent,
    RoomchoiceComponent,
    ViewBookingComponent
  ],
  imports: [
    CommonModule,
    DropDownsModule,
    DialogModule,
    ButtonModule,
    InputsModule,
    GridModule,
    NgxDatatableModule,
    BookingRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    BsModalModule,
    DateInputsModule
  ],
  providers: [PaymentService, BookingService, AddBookingGuard],
  exports: [RoomsComponent, ListGridComponent]
})
export class BookingModule {}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/booking.module.ts